import {getSsoAxios, setUser} from "@/main";

export default class SsoService {
    sendAction(action) {
        return getSsoAxios().post('action',action).then(result => {
            return result.data;
        }).catch(e => {
            if (e.request.status === 403) {
                setUser(null);
            }
            throw e;
        });
    }
    userInfo() {
        return getSsoAxios()
            .get('user-info')
            .then(result => {
                return result.data;
            }).catch(e => {
                throw e;
            });
    }
    consumeSsoAction(actionId) {
        return getSsoAxios()
            .get('action/'+actionId)
            .then(result => {
                return result.data;
            }).catch(e => {
                throw e;
            });
    }
    refreshJwt(refreshToken) {
        return getSsoAxios()
            .post('refresh-jwt', refreshToken)
            .then(result => {
                return result.data;
            }).catch(e => {
                throw e;
            });
    }
    getSsoHomepage() {
        return getSsoAxios()
            .get('sso-homepage')
            .then(result => {
                return result.data;
            }).catch(e => {
                throw e;
            });
    }
}
